export default __webpack_public_path__ + "static/media/settings.ec72ba82.svg";